/* eslint-env browser, amd */

// Load Bootstrap Collapse plugin
require('bootstrap/dist/js/bootstrap.js');
//require('bootstrap/dist/js/umd/collapse.js');

// Load scrollTo script
//var scrollTo = require('./scrollto.js');

(function() {
    // +/- button next to panel title
    var $buttonTre = $('.panel-title .button-tre');

    $('.panel-title a').click(function(e) {
        e.preventDefault();
        var $this = $(this); 
        // If current Button has is +/- button, use $this. Une $this.next is title is clicked
        var currentButton = $(this).hasClass('button-tre') ? $this : $this.next();
        var currentButtonHasLess = currentButton.hasClass('button-less'); 
        var curentTitle = $(this).hasClass('button-tre') ? $this.prev() : $this;
        var linkToContent = curentTitle.attr('href');
        if($(linkToContent).hasClass('collapsing')) {
            return;
        }
        if(currentButtonHasLess) {
            currentButton.toggleClass('button-less', !currentButtonHasLess).toggleClass('button-more', currentButtonHasLess);
        }
        else {
            // Reset +/- button class to button-more
            $buttonTre.removeClass('button-less').addClass('button-more');
            $('.panel-collapse').removeClass('in');
            $('.panel-collapse').attr('aria-expanded', 'false')
            // Toggle +/- button class
            currentButton.toggleClass('button-less', !currentButtonHasLess).toggleClass('button-more', currentButtonHasLess);
        }

        //Scroll to panel title when panel content is open
        //$('#accordion').on('shown.bs.collapse', function() {
        //    scrollTo($this); 
        //});
    });
})();



//////////////////
// WEBPACK FOOTER
// ./source/javascript/es5/bootstrap-collapse.js
// module id = 6
// module chunks = 0